import Vue from 'vue'
export default {
  meta: import('modules/photo/config/meta.js'),
  mock: {
    photo: import('modules/photo/mock/mockPhoto.js'),
  },
  api: {
    mock: import('modules/photo/config/mockApi.js'),
    real: import('modules/photo/config/realApi.js'),
  },
  routes: import('modules/photo/config/routes.js'),
  menu: import('modules/photo/config/menu.js'),
  store: {
    photoManager: import('modules/photo/store/photoManager.js'),
  },
  bootScript: vm => {
    Vue.component('anchorPhotoInfo', () => import('modules/photo/components/photoAction/photoActionInfo.vue'))
    Vue.component('anchorPhotoCopyLink', () => import('modules/photo/components/photoAction/photoActionCopyLink.vue'))
    Vue.component('anchorPhotoView', () => import('modules/photo/components/photoAction/photoActionView.vue'))
    Vue.component('anchorPhotoOpenManager', () => import('modules/photo/components/photoAction/photoActionOpenPhotoManager.vue'))
    Vue.component('anchorSimplePhotoUploader', () => import('modules/photo/components/simplePhotoUploader/simplePhotoUploader.vue'))
  },
}